import gql from 'graphql-tag';

export const UPDATE_RESEARCH_EXPERIENCE = gql`
  mutation (
    $id: ID!
    $pastResearchExperience: String
    $proposedResearchTopic: String
    $proposedResearchPlan: String
    $reasons: String
    $longTermCareerPlan: String
    $expectedContribution: String
    $others: String
    $researchProposal: String
  ) {
    updateResearchExperience(
      id: $id
      input: {
        pastResearchExperience: $pastResearchExperience
        proposedResearchTopic: $proposedResearchTopic
        proposedResearchPlan: $proposedResearchPlan
        reasons: $reasons
        longTermCareerPlan: $longTermCareerPlan
        expectedContribution: $expectedContribution
        others: $others
        researchProposal: $researchProposal
      }
    ) {
      _id
    }
  }
`;
